import React from 'react';
import IFormInputProps from './interfaces/IFormSelectProps';
import ISelectOption from './interfaces/ISelectOption';
import styles from './singleSelect.module.scss';

interface IProps extends IFormInputProps {
  options: ISelectOption[];
  className?: string;
  label?: string;
  value?: ISelectOption['value'];
  customLabel?: boolean;
}

const SingleSelect: React.FC<IProps> = props => {
  const { label = '', className, options, onChangeValue, ...otherProps } = props;
  return (
    <>
      {label && (
        <label hidden id="country_select">
          {label}
        </label>
      )}
      <select
        aria-labelledby="country_select"
        className={`max-w-22 border max-h-[50px] p-2 rounded-md border-gray-300 appearance-none ${className}`}
        data-testid="single-select"
        onChange={onChangeValue}
        {...otherProps}
      >
        {props.customLabel && (
          <option className={styles.option} value={props.value}>
            {props.value}
          </option>
        )}
        {options.map(opt => {
          return (
            <option className={styles.option} key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          );
        })}
      </select>
    </>
  );
};

export default SingleSelect;
